
// import React, { useState, useEffect } from "react";
// import { eventLogReportTableApi } from "../../../../api/Api";
// import { jsPDF } from "jspdf";
// import "jspdf-autotable"; // Ensure autoTable is included
// import * as XLSX from "xlsx";
// import logo from '../../../../assets/img/logos/logo 2.png';
// import { getDateTimeForDashboardTab1, getFromTo } from '../../../../utils'
// import BottomSlider from "../dashboard/dashboardTabs/tab4Content/BottomSlider";
// import TopHeader from "../../../../components/general/TopHeader";

// export default function EventLogReports() {


//     const [startDate, setStartDate] = useState(getDateTimeForDashboardTab1().LastDay)
//     const [endDate, setEndDate] = useState(getDateTimeForDashboardTab1().Today)
//     const[searchQuery,setSearchQuery]=useState("")
//     const[filteredData,setFilteredData]=useState([])

//     const [logData, setLogData] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState(null);
//     const [currentPage, setCurrentPage] = useState(1);
//     const [rowsPerPage] = useState(10); // You can adjust this number as needed
//     const [totalPages, setTotalPages] = useState(1);


//     const credentials = {
//         LOGIN_ID: sessionStorage.getItem("LoginID") || "",
//         PASS_KEY: sessionStorage.getItem("KEY") || "xyz",
//         LCODE: sessionStorage.getItem("LCODE") || "",
//         DT1: startDate,
//         DT2: endDate,
//         WEB_KEY: "WEBXYZ321",
//         FID: "X",
//     };

//     const fetchLogData = async () => {
//         setLoading(true);
//         setError(null);
//         setLogData([]);

//         try {
//             const res = await eventLogReportTableApi(credentials);
//             if (res?.INV_ALARM && Array.isArray(res?.INV_ALARM)) {
//                 setLogData(res?.INV_ALARM);
//                 setTotalPages(Math.ceil(res?.INV_ALARM.length / rowsPerPage)); // Calculate total pages
//             } else {
//                 // console.error("Invalid data structure:", res);
//                 setLogData([]);
//             }
//         } catch (err) {
//             // console.error("Error fetching data:", err);
//             setError("Failed to fetch data. Please try again.");
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchLogData();
//     }, [startDate, endDate]);

//     const tableHeaders = filteredData.length > 0 ? Object.keys(filteredData[0]) : [];
//     const paginatedData = filteredData.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);

//     const goToPage = (page) => {
//         if (page > 0 && page <= totalPages) {
//             setCurrentPage(page);
//         }
//     };

//     // Export to Excel function
//     const exportToExcel = () => {
//         const ws = XLSX.utils.json_to_sheet(logData); // Convert JSON data to Excel sheet
//         const wb = XLSX.utils.book_new(); // Create a new Excel workbook
//         XLSX.utils.book_append_sheet(wb, ws, "Log Data"); // Append sheet to workbook
//         XLSX.writeFile(wb, `Event Log Reports To${new Date().toLocaleDateString()} Event Log Reports.xls`); // Trigger download
//     };

//     // Export to PDF 

//     const exportToPDF = () => {
//         const doc = new jsPDF();
//         const table = document.getElementById("log-table");
//         const rows = Array.from(table.rows);

//         // Extract the header data (first row) and body data (remaining rows)
//         const tableData = [];
//         const headers = Array.from(rows[0].cells).map(cell => cell.innerText.trim());
//         tableData.push(headers);

//         for (let i = 1; i < rows.length; i++) {
//             const rowData = Array.from(rows[i].cells).map(cell => cell.innerText.trim());
//             tableData.push(rowData);
//         }

//         // === Add Logo (x, y, width, height) ===
//         const imgWidth = 20;  // Logo width
//         const imgHeight = 18; // Logo height
//         const xPos = (doc.internal.pageSize.width - imgWidth) / 2;  // Center horizontally
//         doc.addImage(logo, 'PNG', xPos, 10, imgWidth, imgHeight);  // Add logo at the top

//         // === Add Title Below Logo ===
//         const title = `Event Log Reports - ${new Date().toLocaleDateString()}`;  // Dynamic title
//         doc.setFontSize(12);
//         doc.text(title, doc.internal.pageSize.width / 2, 35, { align: 'center' });  // Centered below logo

//         // === Start Table Below Logo & Title ===
//         let startY = 50;  // Push table below the text

//         // Generate PDF Table
//         doc.autoTable({
//             head: [headers],
//             body: tableData.slice(1),  // Exclude header from body data
//             startY: startY,
//             margin: { horizontal: 10 },
//             theme: 'grid',
//             styles: {
//                 cellPadding: 5,
//                 fontSize: 10,
//                 halign: 'center'  // Center align table cells
//             }
//         });

//         // === Save PDF ===
//         doc.save(`Event Log Reports To${new Date().toLocaleDateString()} Event Log Reports`);
//     };



//     useEffect(() => {
//         let updatedData = logData;
//         if (searchQuery.trim() !== "") {
//             updatedData = logData.filter((item) =>
//                 Object.values(item).join(" ").toLowerCase().includes(searchQuery.toLowerCase())
//             );
//         }
//         setFilteredData(updatedData);
//         setTotalPages(Math.ceil(updatedData.length / rowsPerPage));
//         setCurrentPage(1);
//     }, [searchQuery, logData]);


//     return (
//         <>

//             <TopHeader />

//             <div style={{ paddingTop: "4px", fontFamily: "Arial, sans-serif" }}>
//                 {/* Top Section */}
//                 <div className="row">
//                     <div className="col-md-12">
//                         <div style={containerStyle}>
//                             <h6 style={responsiveHeaderStyle}>Event Log Reports</h6>
//                             <div style={responsiveControlsStyle}>
//                                 <label>
//                                     {/* From Date: */}
//                                     <input
//                                         type="date"
//                                         value={startDate}
//                                         onChange={(e) => setStartDate(e.target.value)}
//                                         style={inputStyle}
//                                     />
//                                 </label>
//                                 <label>
//                                     {/* To Date: */}
//                                     To
//                                     <input
//                                         type="date"
//                                         value={endDate}
//                                         onChange={(e) => setEndDate(e.target.value)}
//                                         style={inputStyle}
//                                     />
//                                 </label>
//                                 <button onClick={fetchLogData} style={buttonStyle}>Show</button>
//                                 <button onClick={exportToExcel} style={exportButtonStyle}>Excel</button>
//                                 <button onClick={exportToPDF} style={exportButtonStyle2}>PDF</button>

//                                 <input
//                                     type="text"
//                                     className="form-control form-control-sm "
//                                     placeholder="Search..."
//                                     value={searchQuery}
//                                     onChange={(e) => setSearchQuery(e.target.value)}
//                                     style={{ maxWidth: "150px", height: "1.8rem", borderRadius: "1rem" }}
//                                 />

//                             </div>
// //                         </div>
//                     </div>
//                 </div>
//                 {/* Table Section */}
//                 <div className="table-responsive">
//                     <table id="log-table" className="table table-bordered table-striped table-hover">
//                         <thead style={{ backgroundColor: "rgb(253, 248, 228)" }}>
//                             <tr>
//                                 {tableHeaders.map((header, index) => (
//                                     <th
//                                         key={index}
//                                         className="text-center align-middle"
//                                         style={{
//                                             color: "#56688A",
//                                             padding: "6px 5px",
//                                             whiteSpace: "nowrap",
//                                             minWidth: "100px",
//                                             fontSize: "14px",
//                                             // fontWeight: "bold",
//                                         }}
//                                     >
//                                         {header.replace(/_/g, " ")}
//                                     </th>
//                                 ))}
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {loading ? (
//                                 <tr>
//                                     <td
//                                         colSpan={tableHeaders.length}
//                                         className="text-center"
//                                         style={{ padding: "3px 2px", fontSize: "12px", color: "gray" }}
//                                     >
//                                         Loading...
//                                     </td>
//                                 </tr>
//                             ) : paginatedData.length > 0 ? (
//                                 paginatedData.map((item, rowIndex) => (
//                                     <tr key={rowIndex} className="table-row-hover">
//                                         {tableHeaders.map((key, colIndex) => (
//                                             <td
//                                                 key={colIndex}
//                                                 className="text-center align-middle"
//                                                 style={{
//                                                     padding: "5px 2px",
//                                                     whiteSpace: "nowrap",
//                                                     minWidth: "100px",

//                                                     verticalAlign: "middle",
//                                                 }}
//                                             >
//                                                 {item[key] !== null && item[key] !== undefined ? item[key] : ""}
//                                             </td>
//                                         ))}
//                                     </tr>
//                                 ))
//                             ) : (
//                                 <tr>
//                                     <td
//                                         colSpan={tableHeaders.length}
//                                         className="text-center"
//                                         style={{ padding: "15px", fontSize: "13px", color: "lightblack" }}
//                                     >
//                                         No data available
//                                     </td>
//                                 </tr>
//                             )}
//                         </tbody>
//                     </table>
//                 </div>



//                 {/* Pagination Controls */}
//                 <div style={{ textAlign: "right", marginTop: "20px" }}>
//                     <button onClick={() => goToPage(currentPage - 1)} style={paginationButtonStyle}>
//                         Prev
//                     </button>
//                     <span style={{ margin: "0 10px" }}>
//                         Page {currentPage} of {totalPages}
//                     </span>
//                     <button onClick={() => goToPage(currentPage + 1)} style={paginationButtonStyle}>
//                         Next
//                     </button>
//                 </div>

//                 {/* Error Message */}
//                 {error && <p style={{ color: "red", textAlign: "center" }}>{error}</p>}
//             </div>

//             <BottomSlider />
//         </>

//     );
// }

// 2. Modified code with excel and pdf imaage

// import React, { useState, useEffect } from "react";
// import { eventLogReportTableApi } from "../../../../api/Api";
// import { jsPDF } from "jspdf";
// import "jspdf-autotable"; // Ensure autoTable is included
// import * as XLSX from "xlsx";
// import logo from '../../../../assets/img/logos/logo 2.png';
// import { getDateTimeForDashboardTab1, getFromTo } from '../../../../utils'
// import BottomSlider from "../dashboard/dashboardTabs/tab4Content/BottomSlider";
// import TopHeader from "../../../../components/general/TopHeader";

// export default function EventLogReports() {

//     const [startDate, setStartDate] = useState(getDateTimeForDashboardTab1().LastDay);
//     const [endDate, setEndDate] = useState(getDateTimeForDashboardTab1().Today);
//     const [searchQuery, setSearchQuery] = useState("");
//     const [filteredData, setFilteredData] = useState([]);

//     const [logData, setLogData] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState(null);

//     const [currentPage, setCurrentPage] = useState(1);
//     const [itemsPerPage, setItemsPerPage] = useState(15);

//     const credentials = {
//         LOGIN_ID: sessionStorage.getItem("LoginID") || "",
//         PASS_KEY: sessionStorage.getItem("KEY") || "xyz",
//         LCODE: sessionStorage.getItem("LCODE") || "",
//         DT1: startDate,
//         DT2: endDate,
//         WEB_KEY: "WEBXYZ321",
//         FID: "X",
//     };

//     const fetchLogData = async () => {
//         setLoading(true);
//         setError(null);
//         setLogData([]);

//         try {
//             const res = await eventLogReportTableApi(credentials);
//             if (res?.INV_ALARM && Array.isArray(res?.INV_ALARM)) {
//                 setLogData(res.INV_ALARM);
//             } else {
//                 setLogData([]);
//             }
//         } catch (err) {
//             setError("Failed to fetch data. Please try again.");
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchLogData();
//     }, [startDate, endDate]);

//     const tableHeaders = filteredData.length > 0 ? Object.keys(filteredData[0]) : [];

//     // pagination
//     const indexOfLastItem = currentPage * itemsPerPage;
//     const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//     const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);
//     const totalPages = Math.ceil(filteredData.length / itemsPerPage);

//     const goToPage = (page) => {
//         if (page > 0 && page <= totalPages) {
//             setCurrentPage(page);
//         }
//     };

//     // Excel export
//     const exportToExcel = () => {
//         const ws = XLSX.utils.json_to_sheet(logData);
//         const wb = XLSX.utils.book_new();
//         XLSX.utils.book_append_sheet(wb, ws, "Log Data");
//         XLSX.writeFile(wb, `Event_Log_Reports_${new Date().toLocaleDateString()}.xls`);
//     };

//     // PDF export
//     const exportToPDF = () => {
//         const doc = new jsPDF();
//         const headers = tableHeaders.map((h) => h.replace(/_/g, " "));
//         const body = logData.map((row) => headers.map((h) => row[h.replace(/ /g, "_")]));

//         const imgWidth = 20;
//         const imgHeight = 18;
//         const xPos = (doc.internal.pageSize.width - imgWidth) / 2;
//         doc.addImage(logo, "PNG", xPos, 10, imgWidth, imgHeight);

//         const title = `Event Log Reports - ${new Date().toLocaleDateString()}`;
//         doc.setFontSize(12);
//         doc.text(title, doc.internal.pageSize.width / 2, 35, { align: "center" });

//         doc.autoTable({
//             head: [headers],
//             body: body,
//             startY: 50,
//             margin: { horizontal: 10 },
//             theme: "grid",
//             styles: { cellPadding: 5, fontSize: 10, halign: "center" },
//         });

//         doc.save(`Event_Log_Reports_${new Date().toLocaleDateString()}.pdf`);
//     };

//     // filter + search
//     useEffect(() => {
//         let updatedData = logData;
//         if (searchQuery.trim() !== "") {
//             updatedData = logData.filter((item) =>
//                 Object.values(item).join(" ").toLowerCase().includes(searchQuery.toLowerCase())
//             );
//         }
//         setFilteredData(updatedData);
//         setCurrentPage(1);
//     }, [searchQuery, logData]);


//     return (
//         <>

//             <TopHeader />

//             <div style={{ paddingTop: "4px", fontFamily: "Arial, sans-serif" }}>
//                 {/* Top Section */}
//                 <div className="row">
//                     <div className="col-md-12">
//                         <div style={containerStyle}>
//                             <h6 style={responsiveHeaderStyle}>Event Log Reports
//                                 &nbsp; &nbsp;
//                                 <select
//                                     value={itemsPerPage}
//                                     onChange={(e) => setItemsPerPage(Number(e.target.value))}
//                                 >
//                                     <option value={12}>12</option>
//                                     <option value={15}>15</option>
//                                     <option value={20}>20</option>
//                                     <option value={25}>25</option>
//                                     <option value={50}>50</option>
//                                     <option value={logData.length}>All</option>
//                                 </select>
//                                 <span style={{ marginLeft: "8px" }}>entries</span>
//                             </h6>
//                             <div style={responsiveControlsStyle}>
//                                 <label>
//                                     {/* From Date: */}
//                                     <input
//                                         type="date"
//                                         value={startDate}
//                                         onChange={(e) => setStartDate(e.target.value)}
//                                         style={inputStyle}
//                                     />
//                                 </label>
//                                 <label>
//                                     {/* To Date: */}
//                                     To
//                                     <input
//                                         type="date"
//                                         value={endDate}
//                                         onChange={(e) => setEndDate(e.target.value)}
//                                         style={inputStyle}
//                                     />
//                                 </label>
//                                 <button onClick={fetchLogData} style={buttonStyle}>Show</button>
//                                 <button onClick={exportToExcel} style={exportButtonStyle}>Excel</button>
//                                 <button onClick={exportToPDF} style={exportButtonStyle2}>PDF</button>

//                                 <input
//                                     type="text"
//                                     className="form-control form-control-sm "
//                                     placeholder="Search..."
//                                     value={searchQuery}
//                                     onChange={(e) => setSearchQuery(e.target.value)}
//                                     style={{ maxWidth: "150px", height: "1.8rem", borderRadius: "1rem" }}
//                                 />

//                             </div>
//                         </div>
//                     </div>
//                 </div>
//                 {/* Table Section */}
//                 <div className="table-responsive">
//                     <table id="log-table" className="table table-bordered table-striped table-hover">
//                         <thead style={{ backgroundColor: "rgb(253, 248, 228)" }}>
//                             <tr>
//                                 {tableHeaders.map((header, index) => (
//                                     <th
//                                         key={index}
//                                         className="text-center align-middle"
//                                         style={{
//                                             color: "#56688A",
//                                             padding: "6px 5px",
//                                             whiteSpace: "nowrap",
//                                             minWidth: "100px",
//                                             fontSize: "14px",
//                                             // fontWeight: "bold",
//                                         }}
//                                     >
//                                         {header.replace(/_/g, " ")}
//                                     </th>
//                                 ))}
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {loading ? (
//                                 <tr>
//                                     <td
//                                         colSpan={tableHeaders.length}
//                                         className="text-center"
//                                         style={{ padding: "3px 2px", fontSize: "12px", color: "gray" }}
//                                     >
//                                         Loading...
//                                     </td>
//                                 </tr>
//                             ) : currentData.length > 0 ? (
//                                 currentData.map((item, rowIndex) => (
//                                     <tr key={rowIndex} className="table-row-hover">
//                                         {tableHeaders.map((key, colIndex) => (
//                                             <td
//                                                 key={colIndex}
//                                                 className="text-center align-middle"
//                                                 style={{
//                                                     padding: "5px 2px",
//                                                     whiteSpace: "nowrap",
//                                                     minWidth: "100px",

//                                                     verticalAlign: "middle",
//                                                 }}
//                                             >
//                                                 {item[key] !== null && item[key] !== undefined ? item[key] : ""}
//                                             </td>
//                                         ))}
//                                     </tr>
//                                 ))
//                             ) : (
//                                 <tr>
//                                     <td
//                                         colSpan={tableHeaders.length}
//                                         className="text-center"
//                                         style={{ padding: "15px", fontSize: "13px", color: "lightblack" }}
//                                     >
//                                         No data available
//                                     </td>
//                                 </tr>
//                             )}
//                         </tbody>
//                     </table>
//                 </div>



//                 {/* Pagination Controls */}
//                 <div style={{ textAlign: "right", marginTop: "20px" }}>
//                     <button onClick={() => goToPage(currentPage - 1)} style={paginationButtonStyle}>
//                         Prev
//                     </button>
//                     <span style={{ margin: "0 10px" }}>
//                         Page {currentPage} of {totalPages}
//                     </span>
//                     <button onClick={() => goToPage(currentPage + 1)} style={paginationButtonStyle}>
//                         Next
//                     </button>
//                 </div>

//                 {/* Error Message */}
//                 {error && <p style={{ color: "red", textAlign: "center" }}>{error}</p>}
//             </div>

//             <BottomSlider />
//         </>

//     );
// }



import React, { useState, useEffect } from "react";
import { eventLogReportTableApi } from "../../../../api/Api";
import { jsPDF } from "jspdf";
import "jspdf-autotable"; // Ensure autoTable is included
import * as XLSX from "xlsx";
import logo from '../../../../assets/img/logos/logo 2.png';
import { getDateTimeForDashboardTab1, getFromTo } from '../../../../utils'
import BottomSlider from "../dashboard/dashboardTabs/tab4Content/BottomSlider";
import TopHeader from "../../../../components/general/TopHeader";
import ExportExcel from "../../../../components/exportExcel/ExportExcel1";
import { PASS_KEY, WEB_KEY, BaseUrl } from '../../../../api/AxiosApi'
import { AuthenticationContext } from "../../../../context/AuthenticationContext";
import ExportPdf from "../../../../components/exportPdf/ExportPdf";

export default function EventLogReports() {
 const { LoggedInUserInfo } = React.useContext(AuthenticationContext)
    const [startDate, setStartDate] = useState(getDateTimeForDashboardTab1().LastDay);
    const [endDate, setEndDate] = useState(getDateTimeForDashboardTab1().Today);
    const [searchQuery, setSearchQuery] = useState("");
    const [filteredData, setFilteredData] = useState([]);

    const [logData, setLogData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(15);

    const credentials = {
        LOGIN_ID: sessionStorage.getItem("LoginID") || "",
        PASS_KEY: sessionStorage.getItem("KEY") || "xyz",
        LCODE: sessionStorage.getItem("LCODE") || "",
        DT1: startDate,
        DT2: endDate,
        WEB_KEY: "WEBXYZ321",
        FID: "X",
    };

    const fetchLogData = async () => {
        setLoading(true);
        setError(null);
        setLogData([]);

        try {
            const res = await eventLogReportTableApi(credentials);
            if (res?.INV_ALARM && Array.isArray(res?.INV_ALARM)) {
                setLogData(res.INV_ALARM);
            } else {
                setLogData([]);
            }
        } catch (err) {
            setError("Failed to fetch data. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchLogData();
    }, [startDate, endDate]);

    const ImageUrl = `${BaseUrl}CMN_02/GET_COM_LOGO?LOGIN_ID=${credentials.LOGIN_ID}&LOC_CODE=${credentials.LCODE}&PASS_KEY=${PASS_KEY}&WEB_KEY=${WEB_KEY}`

    const tableHeaders = filteredData.length > 0 ? Object.keys(filteredData[0]) : [];

    // pagination
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(filteredData.length / itemsPerPage);

    const goToPage = (page) => {
        if (page > 0 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    // Excel export
    // const exportToExcel = () => {
    //     const ws = XLSX.utils.json_to_sheet(logData);
    //     const wb = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(wb, ws, "Log Data");
    //     XLSX.writeFile(wb, `Event_Log_Reports_${new Date().toLocaleDateString()}.xls`);
    // };



    // PDF export
    // const exportToPDF = () => {
    //     const doc = new jsPDF();
    //     const headers = tableHeaders.map((h) => h.replace(/_/g, " "));
    //     const body = logData.map((row) => headers.map((h) => row[h.replace(/ /g, "_")]));

    //     const imgWidth = 20;
    //     const imgHeight = 18;
    //     const xPos = (doc.internal.pageSize.width - imgWidth) / 2;
    //     doc.addImage(logo, "PNG", xPos, 10, imgWidth, imgHeight);

    //     const title = `Event Log Reports - ${new Date().toLocaleDateString()}`;
    //     doc.setFontSize(12);
    //     doc.text(title, doc.internal.pageSize.width / 2, 35, { align: "center" });

    //     doc.autoTable({
    //         head: [headers],
    //         body: body,
    //         startY: 50,
    //         margin: { horizontal: 10 },
    //         theme: "grid",
    //         styles: { cellPadding: 5, fontSize: 10, halign: "center" },
    //     });

    //     doc.save(`Event_Log_Reports_${new Date().toLocaleDateString()}.pdf`);
    // };

    const exportToPDF = async () => {
        await ExportPdf(
            ImageUrl,
            currentData,
            startDate,
            endDate,
           "Plant Power Log",
            LoggedInUserInfo,
            logo,
            tableHeaders
    
        );
    };


    const exportToExcel = async () => {
        await ExportExcel(
            ImageUrl,
            logData,
            startDate,
            endDate,
            `Log Data`,
            LoggedInUserInfo
        );
    };

   

    // const exportToPDF = async () => {
    //     await ExportPdf(
    //         ImageUrl,
    //         currentData,
    //         StartDate,
    //         EndDate,
    //         `${TabTitle}_Log`,
    //         LoggedInUserInfo,
    //         logo,
    //         tableHeaders

    //     );
    // };

    // filter + search
    useEffect(() => {
        let updatedData = logData;
        if (searchQuery.trim() !== "") {
            updatedData = logData.filter((item) =>
                Object.values(item).join(" ").toLowerCase().includes(searchQuery.toLowerCase())
            );
        }
        setFilteredData(updatedData);
        setCurrentPage(1);
    }, [searchQuery, logData]);


    return (
        <>

            <TopHeader />

            <div style={{ paddingTop: "4px", fontFamily: "Arial, sans-serif" }}>
                {/* Top Section */}
                <div className="row">
                    <div className="col-md-12">
                        <div style={containerStyle}>
                            <h6 style={responsiveHeaderStyle}>Event Log Reports
                                &nbsp; &nbsp;
                                <select
                                    value={itemsPerPage}
                                    onChange={(e) => setItemsPerPage(Number(e.target.value))}
                                >
                                    <option value={12}>12</option>
                                    <option value={15}>15</option>
                                    <option value={20}>20</option>
                                    <option value={25}>25</option>
                                    <option value={50}>50</option>
                                    <option value={logData.length}>All</option>
                                </select>
                                <span style={{ marginLeft: "8px" }}>entries</span>
                            </h6>
                            <div style={responsiveControlsStyle}>
                                <label>
                                    {/* From Date: */}
                                    <input
                                        type="date"
                                        value={startDate}
                                        onChange={(e) => setStartDate(e.target.value)}
                                        style={inputStyle}
                                    />
                                </label>
                                <label>
                                    {/* To Date: */}
                                    To
                                    <input
                                        type="date"
                                        value={endDate}
                                        onChange={(e) => setEndDate(e.target.value)}
                                        style={inputStyle}
                                    />
                                </label>
                                <button onClick={fetchLogData} style={buttonStyle}>Show</button>
                                <button onClick={exportToExcel} style={exportButtonStyle}>Excel</button>
                                <button onClick={exportToPDF} style={exportButtonStyle2}>PDF</button>

                                <input
                                    type="text"
                                    className="form-control form-control-sm "
                                    placeholder="Search..."
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    style={{ maxWidth: "150px", height: "1.8rem", borderRadius: "1rem" }}
                                />

                            </div>
                        </div>
                    </div>
                </div>
                {/* Table Section */}
                <div className="table-responsive">
                    <table id="log-table" className="table table-bordered table-striped table-hover">
                        <thead style={{ backgroundColor: "rgb(253, 248, 228)" }}>
                            <tr>
                                {tableHeaders.map((header, index) => (
                                    <th
                                        key={index}
                                        className="text-center align-middle"
                                        style={{
                                            color: "#56688A",
                                            padding: "6px 5px",
                                            whiteSpace: "nowrap",
                                            minWidth: "100px",
                                            fontSize: "14px",
                                            // fontWeight: "bold",
                                        }}
                                    >
                                        {header.replace(/_/g, " ")}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td
                                        colSpan={tableHeaders.length}
                                        className="text-center"
                                        style={{ padding: "3px 2px", fontSize: "12px", color: "gray" }}
                                    >
                                        Loading...
                                    </td>
                                </tr>
                            ) : currentData.length > 0 ? (
                                currentData.map((item, rowIndex) => (
                                    <tr key={rowIndex} className="table-row-hover">
                                        {tableHeaders.map((key, colIndex) => (
                                            <td
                                                key={colIndex}
                                                className="text-center align-middle"
                                                style={{
                                                    padding: "5px 2px",
                                                    whiteSpace: "nowrap",
                                                    minWidth: "100px",

                                                    verticalAlign: "middle",
                                                }}
                                            >
                                                {item[key] !== null && item[key] !== undefined ? item[key] : ""}
                                            </td>
                                        ))}
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td
                                        colSpan={tableHeaders.length}
                                        className="text-center"
                                        style={{ padding: "15px", fontSize: "13px", color: "lightblack" }}
                                    >
                                        No data available
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>



                {/* Pagination Controls */}
                <div style={{ textAlign: "right", marginTop: "20px" }}>
                    <button onClick={() => goToPage(currentPage - 1)} style={paginationButtonStyle}>
                        Prev
                    </button>
                    <span style={{ margin: "0 10px" }}>
                        Page {currentPage} of {totalPages}
                    </span>
                    <button onClick={() => goToPage(currentPage + 1)} style={paginationButtonStyle}>
                        Next
                    </button>
                </div>

                {/* Error Message */}
                {error && <p style={{ color: "red", textAlign: "center" }}>{error}</p>}
            </div>

            <BottomSlider />
        </>

    );
}

/* Styles */
const containerStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    marginBottom: "7px",
    border: "1px solid lightgray",
    padding: "3px",
    borderRadius: "7px"
};

const responsiveHeaderStyle = {
    fontWeight: "bold",
    margin: "0",
};

const responsiveControlsStyle = {
    display: "flex",
    flexWrap: "wrap",
    gap: "10px",
    justifyContent: "center",
};

const inputStyle = {
    padding: "3px 9px",
    borderRadius: "12px",
    border: "1px solid #ccc",
    marginLeft: "5px",
    fontSize: "10px",
};



const buttonStyle = {
    backgroundColor: '#007BFF',
    color: '#fff',
    border: 'none',
    borderRadius: '14px',
    padding: '2px 9px',
    cursor: 'pointer',
    fontSize: '10px',
};

const exportButtonStyle = {
    backgroundColor: 'darkblue',
    color: '#fff',
    border: 'none',
    borderRadius: '14px',
    padding: '3px 9px',
    cursor: 'pointer',
    fontSize: '11px',
};

const exportButtonStyle2 = {
    backgroundColor: '#f44336',
    color: '#fff',
    border: 'none',
    borderRadius: '14px',
    padding: '3px 9px',
    cursor: 'pointer',
    fontSize: '11px',
};





const paginationButtonStyle = {
    backgroundColor: "white",
    color: "#356E35",
    border: "1px solid #ddd",
    borderRadius: "7px",
    padding: "6px 12px",
    cursor: "pointer",
    fontSize: "14px",
    margin: "0 5px",
};


